import React from 'react';
import { Message } from "semantic-ui-react";
import { isRecordingSupported } from '../../helpers/supportedFeatureHelper';

export const RecordNotSupportedMessage = () => {
  // Disable if recording is supported
  if(isRecordingSupported()) {
    return null;
  }

  return (
    <Message warning>
      <p>
        Unfortunately, your version of Safari does not support the features needed to
        record a new video. You may still upload an existing video by clicking
        Upload Video button.
      </p>
      <p>
        If you wish to record a video, please open this page {" "}<a href={window.location.href}>{window.location.href}</a> 
        on another browser (such as{" "}<a href="https://www.google.com/chrome/">Chrome</a>)
      </p>
    </Message>
  );
};



// WEBPACK FOOTER //
// ./src/components/RecordNotSupportedMessage/index.jsx